import React from "react"
import {AppModule} from "../appmodule/AppModule";

import HomeIcon from "../../assets/info-red.svg";
import InstrumentsIcon from "../../assets/icn_revio_and_vega.svg";
import RunDesignIcon from "../../assets/icn_run_design.svg";
import DataIcon from "../../assets/icn_data_management.svg";
import SampleSetupIcon from "../../assets/icn_sample_setup.svg";
import SMRTAnalysisIcon from "../../assets/icn_smrt_analysis.svg";
import {useSelector} from "react-redux";
import {ApplicationState} from "../../../../core/types";
import {User} from "../../../../data/model/user-model";
import {
    Access_module_Data_management,
    Access_module_Instruments,
    Access_module_Run_design,
    Access_module_Sample_setup,
    Access_module_SMRT_analysis,
    GetRolesByNames,
    IsAllowedToUse
} from "../userrolemgr/UserRoleMgr";

import {useIsSmrtlinkLite} from "../../../../core/config/use-is-smrtlink-lite";
import {buttonModuleIcon} from "../../assets/css_styles";

export const moduleHomeId = "moduleHome";
export const moduleInstrumentsId = "moduleInstruments";
export const moduleSampleSetupId = "moduleSampleSetup";
export const moduleRunDesignId = "moduleRunDesign"
export const moduleDataManagementId = "moduleDataManagement";
export const moduleSMRTAnalysisId = "moduleSMRTAnalysis";

const txt_home = "Home";
const txt_homeinfo = "Shows available modules and the what's new section.";
const txt_instruments = "Instruments";
const txt_instrumentsinfo = "View and manage your instrument fleet with real-time status monitoring and configuration options";
const txt_rundesign = "Runs";
const txt_rundesigninfo = "View completed and in progress sequencing runs with detailed workflow management.";
const txt_datamgmt = "Data Management";
const txt_datamgmtinfo = "Create and design data sets, organize them into projects or generate reports.";
const txt_samplesetup = "Sample Setup";
const txt_samplesetupinfo = "Determine the final loading dilution volume for samples to sequence with guided protocols.";
const txt_smrtanalysis = "SMRT Analysis";
const txt_smrtanalysisinfo = "Advanced analysis tools and algorithms for comprehensive genomic data interpretation.";
const txt_connected = "Instruments connected to SMRT Link: ";
const txt_activeruns = "Active runs: 0\nRecently completed jobs: 0";

export function GetModuleById(id: string): AppModule | undefined {
    return GetModules(true).find((mod) => mod.id === id);
}

export function GetModules(isShowingHome: boolean): AppModule[] {
    const isSmrtLinkLite = useIsSmrtlinkLite();
    const user = useSelector<ApplicationState, User>(state => state.auth.user);
    const roles = user ? GetRolesByNames(user.roles) : [];
    const allowedInstruments = user ? IsAllowedToUse(roles, Access_module_Instruments) : false;
    const allowedSample_setup = user ? IsAllowedToUse(roles, Access_module_Sample_setup) : false;
    const allowedRun_design = user ? IsAllowedToUse(roles, Access_module_Run_design) : false;
    const allowedData_management = user ? IsAllowedToUse(roles, Access_module_Data_management) : false;
    const allowedSMRT_analysis = user ? IsAllowedToUse(roles, Access_module_SMRT_analysis) : false;
    let modules: AppModule[] = [];

    const homeModule: AppModule = {
        id: moduleHomeId,
        title: txt_home,
        subtitle: txt_homeinfo,
        icon: <div style={buttonModuleIcon}><img src={HomeIcon} alt=""/></div>,
        info: "",
        enabled: true,
        route: "/newhome"
    }

    const instrumentsModule: AppModule = {
        id: moduleInstrumentsId,
        title: txt_instruments,
        subtitle: txt_instrumentsinfo,
        icon: <div style={buttonModuleIcon}><img src={InstrumentsIcon} alt=""/></div>,
        info: txt_connected,
        enabled: allowedInstruments,
        route: "/instruments"
    }

    const sampleSetupModule: AppModule = {
        id: moduleSampleSetupId,
        title: txt_samplesetup,
        subtitle: txt_samplesetupinfo,
        icon: <div style={buttonModuleIcon}><img src={SampleSetupIcon} alt=""/></div>,
        info: "",
        enabled: allowedSample_setup,
        route: "/sample-setup"
    }

    const runDesignModule: AppModule = {
        id: moduleRunDesignId,
        title: txt_rundesign,
        subtitle: txt_rundesigninfo,
        icon: <div style={buttonModuleIcon}><img src={RunDesignIcon} alt=""/></div>,
        info: "",
        enabled: allowedRun_design,
        route: "/runs"
    }

    const smrtAnalysisModule: AppModule = {
        id: moduleSMRTAnalysisId,
        title: txt_smrtanalysis,
        subtitle: txt_smrtanalysisinfo,
        icon: <div style={buttonModuleIcon}><img src={SMRTAnalysisIcon} alt=""/></div>,
        info: txt_activeruns,
        enabled: allowedSMRT_analysis,
        route: "/analysis"
    }

    const dataMgmtModule: AppModule = {
        id: moduleDataManagementId,
        title: txt_datamgmt,
        subtitle: txt_datamgmtinfo,
        icon: <div style={buttonModuleIcon}><img src={DataIcon} alt=""/></div>,
        info: "",
        enabled: allowedData_management,
        route: "/data-management"
    }

    if (isShowingHome) modules.push(homeModule);

    modules.push(instrumentsModule);
    modules.push(sampleSetupModule);
    modules.push(runDesignModule);

    modules.push(dataMgmtModule);

    if (!isSmrtLinkLite) modules.push(smrtAnalysisModule);

    return modules;
}
